import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AuthContextService {
  private readonly transientUserId = crypto.randomUUID();

  constructor(private msalService: MsalService) {}

  getUserId(): string {
    const account = this.msalService.instance.getActiveAccount()
      || this.msalService.instance.getAllAccounts()[0];
    return account?.localAccountId || this.transientUserId;
  }

  getEmail(): string | null {
    const account = this.msalService.instance.getActiveAccount()
      || this.msalService.instance.getAllAccounts()[0];
    return account?.username || null;
  }

  getDisplayName(): string | null {
    const account = this.msalService.instance.getActiveAccount()
      || this.msalService.instance.getAllAccounts()[0];
    if (account?.name?.trim()) {
      return account.name;
    }

    const email = account?.username;
    return email ? email.split('@')[0] : null;
  }
}
